// Whether the desktop rail shows its labels or folds to icons, remembered per browser like the
// colour mode (theme/mode.ts). The drawer below xl always shows labels.
import { useState } from "react";

export type RailWidth = "expanded" | "collapsed";

/** The rail's width, and the content column's offset beside it; they must agree. */
export const RAIL_CLASS: Record<RailWidth, string> = {
  expanded: "w-[284px]",
  collapsed: "w-[96px]",
};
export const RAIL_OFFSET: Record<RailWidth, string> = {
  expanded: "xl:ms-[284px] xl:w-[calc(100%-284px)]",
  collapsed: "xl:ms-[96px] xl:w-[calc(100%-96px)]",
};

const KEY = "ocs.rail";

function saved(): RailWidth {
  try {
    return localStorage.getItem(KEY) === "collapsed" ? "collapsed" : "expanded";
  } catch {
    // Storage can be blocked (private mode); start expanded.
    return "expanded";
  }
}

export function useRailWidth(): [RailWidth, (width: RailWidth) => void] {
  const [width, setWidth] = useState(saved);
  const choose = (next: RailWidth) => {
    setWidth(next);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Not persisting the choice is fine.
    }
  };
  return [width, choose];
}
